import { render, staticRenderFns } from "./InstanceEditDialog.vue?vue&type=template&id=e1b5453e&"
import script from "./InstanceEditDialog.vue?vue&type=script&lang=js&"
export * from "./InstanceEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports